export default "__VITE_ASSET__DhKgS43P__"